exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".core-layout__viewport{padding-top:4rem}", "", {"version":3,"sources":["/./src/layouts/CoreLayout/src/layouts/CoreLayout/CoreLayout.scss"],"names":[],"mappings":"AAAA,uBACE,gBAAkB,CACnB","file":"CoreLayout.scss","sourcesContent":[".core-layout__viewport {\n  padding-top: 4rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap&-minimize!./~/postcss-loader!./~/sass-loader?sourceMap!./src/layouts/CoreLayout/CoreLayout.scss
// module id = 376
// module chunks = 0